module.exports = __webpack_public_path__ + "static/paneltabs-fd76a44575aa9d2504c95c94b0c3ef76.mp4";